import SelectTableFooter from './SelectTableFooter';

export default SelectTableFooter;
